import type { ptBR } from './pt-BR';

export const ja: typeof ptBR = {
  appName: 'GBFR Save Analytics',
  tagline: 'データ分析＆セーブデータ修正',
  open: 'セーブデータを開く',
  compareWith: '別のデータと比較…',
  download: '修正済みセーブをダウンロード',
  downloading: 'ハッシュ再計算中…',
  undoAll: 'すべて元に戻す',
  language: '言語',
  fileInfo: '{name} · {size} MB · {units} ユニット',

  navAnalysis: '分析',
  navData: 'データ',
  dashboard: 'ダッシュボード',
  characters: 'キャラクター',
  sigils: 'ジーン',
  materials: 'トレジャー',
  weapons: '武器',
  otherItems: 'その他アイテム',
  explore: '全データ閲覧',
  ids: 'ID一覧テーブル',
  compare: 'セーブ比較',
  changes: '変更履歴',

  welcomeTitle: '変更を加える前に、セーブデータを確認しましょう。',
  welcomeBody: '『グランブルーファンタジー リリンク』の SaveData1.dat を読み込み、キャラクター、ジーン、トレジャー、武器の確認や2つのセーブデータの比較、値の修正が行えます。ファイルはブラウザ内でのみ処理され、外部サーバー等には一切送信されません。',
  dropHere: 'ここに SaveData1.dat をドロップ',
  orChoose: 'またはファイルを選択',
  whereIsSave: 'セーブデータはゲームの SaveGames フォルダ内にあり、SaveData1_BackUp.dat や SaveData1_BackUp2.dat バックアップと同じ場所に保存されています。',
  step1: 'セーブデータを開き、整合性ハッシュを確認します。',
  step2: 'ダッシュボードで内容を確認。バックアップと比較して変更点を確認できます。',
  step3: '慎重に数値を編集後、修正済みセーブをダウンロードし、ゲームを終了した状態で置き換えます。',
  readError: '{name} を読み込めませんでした。Relinkのセーブデータではない可能性があります。',
  configFile: 'これは設定ファイルであり、進行状況のセーブデータではありません。「全データ閲覧」から各フィールドを確認・編集できます。',

  responsibilityTitle: 'ご利用前の注意事項',
  responsibilityBody: '本ツールはデータ分析および修正ツールです。セーブデータへの変更およびその結果については、すべて利用者ご自身の自己責任となります。ファイルを置き換える前に、必ず元のセーブデータのバックアップを作成してください。',
  responsibilityPoints1: 'セーブデータはお使いのブラウザ内でのみ処理され、外部へのアップロードは一切行われません。',
  responsibilityPoints2: '多くのフィールドは推測に基づくものであり、各項目に確信度（信頼度）を表示しています。',
  responsibilityPoints3: '本ツールはファンプロジェクトであり、株式会社Cygamesとは一切関係ありません。',
  responsibilityAccept: '理解した上で自己責任で使用する',
  footerNotice: 'データ分析および修正ツール。セーブデータの変更はすべて自己責任となります。Cygames公式とは一切関係ありません。',
  downloadNotice: 'ダウンロードおよび変更の適用は自己責任で行ってください。ゲームを完全に終了し、元のファイルのバックアップを保管してください。',
  namesCredit: '名称データ: Nenkai/relink-modding',
  namesOffline: '名称リストに接続できません。IDのみ表示します。',
  namesLoading: '名称を読み込み中…',
  source: 'ソースコード',
  madeBy: '開発者',
  music: 'テーマ曲',
  musicTurnOn: 'テーマ曲を再生',
  musicTurnOff: 'テーマ曲を停止',
  sfx: '効果音',
  sfxTurnOn: '効果音を有効化',
  sfxTurnOff: '効果音を無効化',

  inParty: '現在の編成中',
  sigilsWorn: '装備中のジーン',
  noWeapons: 'セーブ内にこのキャラクターの武器がありません。',
  noSigils: 'ジーンが装備されていません。',
  sheetNote: 'セーブデータから読み込まれた値です。変更するには編集テーブルを使用してください。',
  editCharacter: 'キャラクターを編集',
  prevChar: '前のキャラクター',
  nextChar: '次のキャラクター',
  close: '閉じる',

  sealOk: 'ハッシュ正常',
  sealBad: 'ハッシュ不一致',
  sealFixed: 'ハッシュ再計算済み',
  sealNone: 'ハッシュなし',
  sealOkBody: 'XXHash64 整合性ハッシュ（#{index}）はファイルと一致しています。',
  sealBadBody: 'ハッシュ #{index} が一致しません。ゲーム起動時にデータ破損と判定されます。ダウンロード時に自動修復されます。',
  sealFixedBody: '変更内容に合わせてハッシュ #{index} を再計算しました。',
  sealNoneBody: 'このファイルには整合性ハッシュが含まれていません。',
  sealPending: 'ハッシュ保留中',
  stamp_ok: '正常', stamp_bad: '破損', stamp_fixed: '更新', stamp_pending: '保留中', stamp_none: 'ハッシュなし',
  sealPendingBody: '未適用の変更があります。ダウンロード時にハッシュが再計算されます。',
  confidence: '確信度',
  confirmed: '確定',
  likely: '濃厚',
  possible: '推測',
  unknown: '不明',

  rupies: 'ルピ',
  maxedChars: 'Lv 100',
  unknownChar: '不明なキャラクター',
  maxShort: 'MAX',
  noOwner: '所持者不明',
  howItWorks: '使い方',
  analysis: 'セーブ分析',
  charEditTitle: 'キャラクター編集',
  forGame: 'for グランブルーファンタジー リリンク',
  artCredit: '画像およびロゴ © Cygames（ファンプロジェクトにて使用）。',
  sigilCount: 'ジーン',
  materialKinds: 'トレジャー',
  weaponCount: '武器',
  sinceCompare: '{name} との差分: {delta}',
  playerName: '主人公',
  profileName: 'プロフィール名',
  party: '現在の編成',
  lastSaved: '最終セーブ日時',

  charProgress: 'キャラクター育成状況',
  charProgressNote: '加入済みキャラクターのレベル（金色＝最大レベル）。',
  level: 'レベル',
  exp: '経験値',
  hp: 'HP',
  atk: '攻撃力',
  msp: 'MSP',
  progress: '進捗',
  character: 'キャラクター',
  charEditNote: 'レベルを変更する際は、経験値（Lv100＝8,400,000）も合わせて調整してください（ゲーム側で再計算される場合があります）。HP・攻撃力・MSPは推定値です。',

  sigilLevels: 'レベル別ジーン数',
  topSigils: '所持数の多いジーン',
  sigilsByChar: 'キャラクター別装備ジーン',
  sigil: 'ジーン',
  wornBy: '装備キャラ',
  serial: 'シリアル',
  count: '個数',
  duplicates: '重複',

  topMaterials: '所持数の多いトレジャー',
  scarceMaterials: '枯渇寸前のトレジャー',
  material: 'トレジャー',
  quantity: '所持数',

  weaponsByChar: 'キャラクター別所持武器',
  weapon: '武器',
  owner: '所持者',
  uncap: '上限解放',
  awakening: '覚醒',
  wrightstone: '加護',
  appearance: 'スキン（見た目）',

  evolution: 'セーブデータ間の変化',
  evolutionEmpty: '「別のデータと比較…」から2つ目のセーブ（例: SaveData1_BackUp2.dat）を開くと、獲得・消費したアイテムやレベルの推移が表示されます。',
  rupiesDelta: 'ルピ',
  materialDeltas: '獲得・消費トレジャー',
  levelUps: '上昇レベル',
  sigilsGained: '増加したジーン',
  weaponsGained: '増加した武器',
  gained: '獲得',
  spent: '消費',
  sideA: 'データA · {name}',
  sideB: 'データB · {name}',

  wrightstones: '加護',
  curios: '遺物',
  list1901: 'リスト1901 (詳細不明)',

  filter: '名前またはIDで絞り込み…',
  filterValue: '値、名前、説明で検索…',
  shown: '{shown} / {total} 件',
  tooMany: '全 {total} 件中 {shown} 件を表示しています。絞り込んでください。',
  allTypes: 'すべての型',
  allSections: 'すべてのセクション',
  onlyNonZero: '非ゼロのみ',
  section: 'セクション',
  type: '型',
  value: '値',
  description: '説明',
  edit: '編集',
  showing: '{total} 件中 {n} 件を表示中。',
  empty: '(空)',
  none: '—',
  viewTable: '表で見る',

  idsIntro: '各IDはデータの種類を表し、ユニット番号ごとに個別エントリ（アイテム、キャラクターなど）に分かれています。入力したメモはこのブラウザに保存されます。',
  group: 'グループ',
  note: 'メモ',
  notePlaceholder: 'メモを入力…',
  onlyDescribed: '説明またはメモがある項目のみ',
  exportNotes: 'メモを書き出し',
  importNotes: 'メモを取り込み',
  importError: '取り込み失敗: {msg}',
  view: '表示',
  example: '例',
  noDescription: '説明なし',

  compareIntro: '「別のデータと比較…」で別のセーブを選択してください。ヒント: セーブを複製し、ゲーム内で1つだけ操作してセーブ・比較することで、未知のIDを特定できます。',
  differences: '差分: {a} → {b} ({n} 箇所)',
  refersTo: '参照先',
  change: '変更',
  compareFirst: '先にメインのセーブデータを開いてください。',

  changesTitle: '保留中の変更 ({n})',
  noChanges: '変更はありません。',
  field: 'フィールド',
  undo: '元に戻す',
  changesHelp: '適用方法: 「修正済みセーブをダウンロード」をクリックし、ゲームを終了した状態でセーブフォルダ内の {name} を置き換えます（元のファイルは保管推奨）。ダウンロードされるファイルは元のファイルと同サイズで、変更したバイトと整合性ハッシュのみ更新されます。',

  errNan: '数値を入力してください。',
  errInt: '整数で入力してください。',
  errRange: '{lo}〜{hi} の範囲で入力してください。',
  unsavedWarning: 'まだダウンロードされていない変更があります。',

  groupplayer: 'プレイヤー', groupprogress: '進行状況', groupintegrity: '整合性', groupworld: 'ワールド', groupdates: '日時',
  grouponline: 'オンライン', groupparty: '編成', groupcharacters: 'キャラクター', groupmaterials: 'トレジャー', groupitems: 'アイテム',
  groupwrightstones: '加護', groupsigils: 'ジーン', groupweapons: '武器', groupcollection: '図鑑・収集', grouploadscreen: 'ロード画面',
};
